module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/watch-2-f5fe503e36b609f2667f65ae2ea8c41a.svg";